export const STATE_IDENTIFIER = {
  TABLES_CONFIGURATION: "tablesConfiguration",
  LOADER_IDENTIFIER: "loader",
};

export enum ISectionType {
  HISTORY_REQUEST = "HISTORY_REQUEST",
  EXAMINE_USERS = "EXAMINE_USERS",
  EXAMINE_ENTITLEMENTS = "EXAMINE_ENTITLEMENTS",
  USER_ENTITLEMENTS = "USER_ENTITLEMENTS",
  CATALOG = "CATALOG",
  ENTITLEMENTS_REQUEST = "ENTITLEMENTS_REQUEST",
  EMERGENCY_USERS_RACF = "EMERGENCY_USERS_RACF",
  TEMPORARY_ENTITLEMENTS = "TEMPORARY_ENTITLEMENTS",
  DELEGATIONS = "DELEGATIONS",
  APPROVALS = "APPROVALS",
  TASKS = "TASKS",
  SERVICE_REQUESTS = "SERVICE_REQUESTS",
  MANUALS = "MANUALS",
  BUSINESS_ROLES = "BUSINESS_ROLES",
  PASSWORD_RESET = "PASSWORD_RESET",
  CHANGE_PASSWORD = "CHANGE_PASSWORD",
  PROFILE_MANAGEMENT = "PROFILE_MANAGEMENT",
  EXAMINE_RECERTIFICATION_CAMPAIGNS = "EXAMINE_RECERTIFICATION_CAMPAIGNS",
  EXTERNAL_PORTAL = "EXTERNAL_PORTAL",
  REPORTS = "REPORTS",
}
export enum ITableType {
  REQUESTS_TABLE = "REQUESTS_TABLE",
  ENTITLEMENTS_TABLE = "ENTITLEMENTS_TABLE",
  TEMPORARY_TABLE = "TEMPORARY_TABLE",
  USERS_TABLE = "USERS_TABLE",
  ACCOUNTS_TABLE = "ACCOUNTS_TABLE",
  EMERGENCY_USERS_TABLE = "EMERGENCY_USERS_TABLE",
  DELEGATES_TABLE = "DELEGATES_TABLE",
  MANUALS_TABLE = "MANUALS_TABLE",
  BUSINESS_ROLES_TABLE = "BUSINESS_ROLES_TABLE",
  PASSWORDS_TABLE = "PASSWORDS_TABLE",
  CAMPAIGN_TABLE = "CAMPAIGN_TABLE",
  OUS_TABLE = "OUS_TABLE",
  CAMPAIGN_ENTITLEMENTS_TABLE = "CAMPAIGN_ENTITLEMENTS_TABLE",
  CAMPAIGN_USERS_TABLE = "CAMPAIGN_USERS_TABLE",
  REPORTS_TABLE = "REPORTS_TABLE",
  TASKS_REQUESTS_TABLE = "TASKS_REQUESTS_TABLE",
  SOCIETY_VALIDATION_USERS_TABLE = "SOCIETY_VALIDATION_USERS_TABLE",
}

export interface IColumnConfiguration {
  key: string;
  visibility: boolean;
  position: number;
}
export interface ITableConfiguration {
  idTable: string;
  section?: ISectionType;
  type?: ITableType;
  role?: "BASIC_USER" | "ADMIN";
  columns: IColumnConfiguration[];
}
export interface ITablesConfigurationResponse {
  tablesConfiguration: ITableConfiguration[];
}
